import PropTypes from 'prop-types';
import React from 'react';
import { SelectSearch } from 'mol-ui';
import { uppercaseFirst } from 'shared/utils';

const means = ['call', 'email', 'sms', 'whatsapp'];

const selectOptions = means.map(mean => ({
    label: uppercaseFirst(mean),
    value: mean
}));

const NotificationMeanPicker = ({
    onChange,
    value
}) => {

    const selectProps = {
        onChange,
        value,
        width: '100%'
    };

    return (
        <SelectSearch
            allowNone={ false }
            { ...selectProps }
            options={ selectOptions }
        />
    );
};

NotificationMeanPicker.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string
};

export default NotificationMeanPicker;
